/**
 * Maximum length of a share reference. Mirrors `REFERENCE_MAX_LENGTH` in the backend's
 * `src/smart_share/models.py`, where the column is a `CharField(max_length=60)` — anything longer is
 * rejected server-side.
 *
 * Enforced identically by the share creation form (`ShareAssetModal`) and by inline reference edits
 * on the active shares table (`EditableReference`). The validation messages in both features quote
 * this number as a literal, so keep them in step when it changes — `EditableReference.utils.test.ts`
 * guards against that drift.
 */
export const REFERENCE_MAX_LENGTH = 60
